import React, { ForwardedRef, forwardRef, HTMLProps } from 'react';

import { Flex } from 'common/components/Grids/Grids.styled';
import { useMasonry } from 'common/components/Grids/useMasonry';

interface IProps extends Omit<HTMLProps<HTMLDivElement>, 'as'> {
  columns: number;
  direction?: 'row' | 'column';
  gap?: number | string;
  /** Lay out each column as a flex container so items with `fullHeight` can grow to balance column heights. */
  stretch?: boolean;
}

const Masonry = forwardRef(
  (
    { columns, direction = 'row', gap, stretch, children, ...rest }: IProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const { sectionItems } = useMasonry(columns, children, direction);

    return (
      <Flex
        $direction={direction}
        $columns={columns}
        $gap={gap}
        $stretch={stretch}
        {...rest}
        ref={ref}
      >
        {sectionItems.map((items, index) => (
          <div key={index}>{items}</div>
        ))}
      </Flex>
    );
  },
);

Masonry.displayName = 'Masonry';

export { Masonry };
